import { palette } from './palette'

export const BUTTON_THEME_COLOR = palette.navy
export const BUTTON_LIGHT_TEXT = palette.cream
export const BUTTON_HOVER_FILL = '#ffffff'

export const BUTTON_TRANSITION = 'all 0.65s cubic-bezier(0.62, 0.05, 0.01, 0.99)'
const HOVER_BORDER = `1px solid ${BUTTON_THEME_COLOR}`

const buttonMaskSx = {
  WebkitMaskImage: '-webkit-radial-gradient(#fff, #000)',
}

function createTextSlideSx(hoverColor) {
  return {
    '& .btn-text': {
      position: 'relative',
      overflow: 'hidden',
      zIndex: 2,
      color: 'inherit',
      display: 'inline-block',
      lineHeight: 'inherit',
    },
    '& .btn-text-orig': {
      display: 'inline-block',
      transition: BUTTON_TRANSITION,
      transform: 'translateY(0)',
    },
    '& .btn-text-clone': {
      position: 'absolute',
      left: 0,
      top: 0,
      display: 'inline-block',
      transform: 'translateY(100%)',
      transition: BUTTON_TRANSITION,
      color: hoverColor,
    },
    '&:hover .btn-text-orig': {
      transform: 'translateY(-100%)',
    },
    '&:hover .btn-text-clone': {
      transform: 'translateY(0)',
    },
  }
}

function createArrowSwapSx({ lightDefault = true }) {
  return {
    '& .figma-btn-arrow-light': {
      opacity: lightDefault ? 1 : 0,
      transition: BUTTON_TRANSITION,
    },
    '& .figma-btn-arrow-dark': {
      opacity: lightDefault ? 0 : 1,
      transition: BUTTON_TRANSITION,
      position: 'absolute',
      inset: '-4.69% -7.5% -3.39% -7.5%',
      width: 'calc(100% + 15%)',
      height: 'calc(100% + 8.08%)',
      maxWidth: 'none',
    },
    '&:hover .figma-btn-arrow-light': {
      opacity: lightDefault ? 0 : 1,
    },
    '&:hover .figma-btn-arrow-dark': {
      opacity: lightDefault ? 1 : 0,
    },
  }
}

function createBlobFillSx(hoverFill) {
  return {
    '&::before': {
      content: '""',
      position: 'absolute',
      backgroundColor: hoverFill,
      height: '200%',
      width: 'calc(100% + 2.5rem)',
      left: '-20px',
      top: '250%',
      transform: 'translateY(-50%)',
      zIndex: 0,
      borderRadius: '50%',
      transition: BUTTON_TRANSITION,
      pointerEvents: 'none',
    },
    '&:hover::before': {
      top: '50%',
    },
  }
}

function createButtonHoverSx({
  bgcolor,
  color,
  borderColor = 'transparent',
  hoverFill = BUTTON_HOVER_FILL,
  hoverColor = BUTTON_THEME_COLOR,
  lightArrowDefault = true,
}) {
  return {
    position: 'relative',
    overflow: 'hidden',
    isolation: 'isolate',
    boxSizing: 'border-box',
    whiteSpace: 'nowrap',
    border: borderColor === 'transparent' ? '1px solid transparent' : `1px solid ${borderColor}`,
    transition: BUTTON_TRANSITION,
    bgcolor,
    color,
    ...buttonMaskSx,
    ...createBlobFillSx(hoverFill),
    '& > *': {
      position: 'relative',
      zIndex: 2,
    },
    ...createTextSlideSx(hoverColor),
    ...createArrowSwapSx({ lightDefault: lightArrowDefault }),
    '&:hover': {
      bgcolor,
      border: HOVER_BORDER,
      borderColor: BUTTON_THEME_COLOR,
      boxShadow: 'none',
    },
    '&.Mui-disabled': {
      '&::before': {
        display: 'none',
      },
    },
  }
}

/** Navy bg → white fill + navy text on hover */
export const buttonHoverPrimarySx = createButtonHoverSx({
  bgcolor: BUTTON_THEME_COLOR,
  color: BUTTON_LIGHT_TEXT,
  hoverFill: BUTTON_HOVER_FILL,
  hoverColor: BUTTON_THEME_COLOR,
  lightArrowDefault: true,
})

/** White/cream bg → navy fill + white text on hover */
export const buttonHoverSecondarySx = createButtonHoverSx({
  bgcolor: BUTTON_LIGHT_TEXT,
  color: BUTTON_THEME_COLOR,
  hoverFill: BUTTON_THEME_COLOR,
  hoverColor: BUTTON_LIGHT_TEXT,
  lightArrowDefault: false,
})

export const buttonHoverOutlineSx = createButtonHoverSx({
  bgcolor: 'transparent',
  color: BUTTON_THEME_COLOR,
  borderColor: BUTTON_THEME_COLOR,
  hoverFill: BUTTON_THEME_COLOR,
  hoverColor: BUTTON_LIGHT_TEXT,
  lightArrowDefault: false,
})

export const buttonHoverLightBorderedSx = createButtonHoverSx({
  bgcolor: BUTTON_LIGHT_TEXT,
  color: BUTTON_THEME_COLOR,
  borderColor: BUTTON_THEME_COLOR,
  hoverFill: BUTTON_THEME_COLOR,
  hoverColor: BUTTON_LIGHT_TEXT,
  lightArrowDefault: false,
})

export function buttonHoverFilterSx(isActive) {
  return isActive ? buttonHoverPrimarySx : buttonHoverLightBorderedSx
}
